import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { ClientEmployeeContactBO, ContactInfoLst } from './client-employee-contact.model';
import { CommonApiService } from 'src/app/commonapiservice';
import { GeneralService } from 'src/app/service/general.service';
import { emailValidator } from '../password/password.component';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-client-employee-contact',
  templateUrl: './client-employee-contact.component.html',
  styleUrls: ['./client-employee-contact.component.scss']
})
export class ClientEmployeeContactComponent implements OnInit {
  ClientEmployeeContact: ClientEmployeeContactBO =
  new ClientEmployeeContactBO();
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() ContactRelation: ClientEmployeeContactBO;
  ClientEmployeeContactData: ContactInfoLst[] = [];
  ContactTypeList: [{ Key: number, Value: string }];
  ContactRelationshipList: [{ Key: number, Value: string }];
  phoneCarrierList: [{ Key: number, Value: string }];
  ContactInfoForm: FormGroup;
  disabledsavedbutton: boolean = false;
  stateList: any = [];
  isCheckContactvalue: boolean = false;
  contactinfo: ContactInfoLst = new ContactInfoLst();
  ContactId: any;
  checkEmailValidation: boolean = false
  constructor(public CommonAPI: CommonApiService, public formBuilder: FormBuilder, public global: GlobalComponent,
    public toastrService: ToastrService, public general: GeneralService,) {
    this.ContactInfoForm = this.formBuilder.group({
      Name: [' ', Validators.required],
      ContactTypes: [' ', Validators.required],
      phoneCarrier: [' ',],
      RelationshipType: [' ',],
      phoneNumber: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      alternatePhoneNumber: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      fax: [' ', [Validators.minLength(14), Validators.maxLength(14)]],
      street: [' '],
      city: [' '],
    //  email: ['', Validators.compose([Validators.email, emailValidator])],
      email: ['',Validators.pattern('^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')],
      state: [' '],
      zip: [' '],
    })
  }
  ngOnInit(): void {

console.log(this.ContactRelation);

    if (this.ContactRelation?.ContactType == 'Client' || this.global.OnboardType=='CLIENT' ) {
      this.getClientContactInfo();
    }
    else if (this.ContactRelation?.ContactType == 'Employee' || this.global.OnboardType=='CLIENT') {
      this.getEmployeeContactInfo();
    }
    else if (this.ContactRelation?.ContactType == 'Referral'){
      this.getReferralContactInfo();
    }
    this.getContactType();
    this.getContactRelationStatus();
    this.getPhoneCarrierStatus();
    this.CommonAPI.getStateJson().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;
    });

    this.getpermission();
  }
  selectedContactdetails(ContactDetails: ContactInfoLst) {
    this.contactinfo = JSON.parse(JSON.stringify(ContactDetails));

  }
  showOrHideAdditionalDetails(index) {
    this.ClientEmployeeContactData[index].showAdditionalDetails = !(this.ClientEmployeeContactData[index].showAdditionalDetails);
  }
  setDeleteId(value) {
    this.ContactId = value;
  }
  refreshToGetDropDownValues(ListCode: string) {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", ListCode);
    this.CommonAPI.RefreshDropDownList(ListCode, params, url, "LovDropDown").then((data: any) => {
      if (ListCode == 'CONTACTTYPE') {
        this.ContactTypeList = data;
      }
      if (ListCode == 'RELATIONSHIP') {
        this.ContactRelationshipList = data;
      }
      if (ListCode == 'PHONECARRIER') {
        this.phoneCarrierList = data;
      }
    })
  }
  getContactType() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "CONTACTTYPE");
    this.CommonAPI.getDropDownList('CONTACTTYPE', params, url, "LovDropDown").then((data: [{ Key: number, Value: string }]) => {
      this.ContactTypeList = data;
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }
  DemographicPhoneFormat() {
    this.contactinfo.phoneNumber = this.general.converPhoneGoogleLib(this.contactinfo.phoneNumber)
    this.contactinfo.alternatePhoneNumber = this.general.converPhoneGoogleLib(this.contactinfo.alternatePhoneNumber)
    this.contactinfo.fax = this.general.converPhoneGoogleLib(this.contactinfo.fax)
  }
  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  getContactRelationStatus() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "RELATIONSHIP");
    this.CommonAPI.getDropDownList('RELATIONSHIP', params, url, "LovDropDown").then((data: [{ Key: number, Value: string }]) => {
      this.ContactRelationshipList = data;
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }
  getPhoneCarrierStatus() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "PHONECARRIER");
    this.CommonAPI.getDropDownList('PHONECARRIER',params, url, "LovDropDown").then((data: any) => {
      this.phoneCarrierList = data;
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }
  Delete() {
    let param = new URLSearchParams()
    param.append("Id", this.ContactId)
    let url=''
    if (this.ContactRelation?.ContactType == 'Client' ) {
      url = "api/ClientContactInfo/DeleteCliContactInfo?";
    }
    else if (this.ContactRelation?.ContactType == 'Employee' ) {
      url = "api/EmployeeContactInfo/DeleteEmpContactInfo?";
    }
   else if (this.ContactRelation?.ContactType == 'Referral'){
    url = "api/ReferralContactInfo/DeleteReferralContactInfo?";
   }
    
    this.CommonAPI.DeleteFunctionForDeleteHttp(param, url).subscribe((data: any) => {
      this.toastrService.success("Contact deleted successfully!");
      document.getElementById("openDelete").click();
      if (this.ContactRelation?.ContactType == 'Client' || this.global.OnboardType=='CLIENT') {
        this.getClientContactInfo();
      }
      else if (this.ContactRelation?.ContactType == 'Employee' || this.global.OnboardType=='EMPLOYEE') {
        this.getEmployeeContactInfo();
      }
      else if(this.ContactRelation?.ContactType == 'Referral'){
        this.getReferralContactInfo();
      }

    },
      (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
  }
  getClientContactInfo() {
    let params = new URLSearchParams();
    if(this.ContactRelation != null && this.ContactRelation!= undefined)
    {
      params.append("clientId", this.ContactRelation.Id.toString());
    }else{
      params.append("clientId", this.global.cfssLoginEntityId);
    }
  


    let url = "api/ClientContactInfo/GetCliContactInfo?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClientEmployeeContactData = data;
      this.ClientEmployeeContactData?.forEach(ele => {
        ele.phoneNumber = (ele.phoneNumber != null) ? this.general.converPhoneGoogleLib(ele.phoneNumber) : null;
        ele.alternatePhoneNumber = (ele.alternatePhoneNumber != null) ? this.general.converPhoneGoogleLib(ele.alternatePhoneNumber) : null;
      })
    },
      (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
  }
  getEmployeeContactInfo() {
    let params = new URLSearchParams();
    if(this.ContactRelation != null && this.ContactRelation!= undefined)
      {
        params.append("EmployeeId", this.ContactRelation.Id.toString());
      }else{
        params.append("EmployeeId", this.global.cfssLoginEntityId);
      }
   
    let url = "api/EmployeeContactInfo/GetEmpContactInfo?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClientEmployeeContactData = data;
      this.ClientEmployeeContactData?.forEach(ele => {
        ele.phoneNumber = (ele.phoneNumber != null) ? this.general.converPhoneGoogleLib(ele.phoneNumber) : null;
        ele.alternatePhoneNumber = (ele.alternatePhoneNumber != null) ? this.general.converPhoneGoogleLib(ele.alternatePhoneNumber) : null;
      })

    },
      (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
  }
  getzipcode() {
    let myParams = new URLSearchParams();
    myParams.append("Street", this.contactinfo.street)
    myParams.append("City", this.contactinfo.city)
    myParams.append("State", this.contactinfo.state)
    let url = "api/Client/getZipcode?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(myParams, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.contactinfo.zipCode = data.zipcode;
    },

      (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      });
  }
  SaveOrUpdateContactInfo() {
    this.disabledsavedbutton = true;
    let saveEmployeeContact: ContactInfoLst = JSON.parse(JSON.stringify(this.contactinfo));
    saveEmployeeContact.id = this.contactinfo.id;
    if (this.ContactRelation?.ContactType == 'Client' ) {
      saveEmployeeContact.clientId = (this.ContactRelation != null && this.ContactRelation!= undefined)? this.ContactRelation.Id : this.global.cfssLoginEntityId;
    }
    else if (this.ContactRelation?.ContactType == "Employee" ) {
      saveEmployeeContact.employeeId = (this.ContactRelation != null && this.ContactRelation!= undefined)? this.ContactRelation.Id : this.global.cfssLoginEntityId;
    }
    else if ( this.ContactRelation?.ContactType == 'Referral'){
      saveEmployeeContact.referralId = this.global.referralId;
    }
    saveEmployeeContact.contactTypeLid = this.contactinfo.contactTypeLid;
    saveEmployeeContact.relationshipLid = saveEmployeeContact.relationshipLid != null ? this.contactinfo.relationshipLid: null;
    saveEmployeeContact.phoneCarrierLid = saveEmployeeContact.phoneCarrierLid != null ? this.contactinfo.phoneCarrierLid : null;
    if (saveEmployeeContact.alternatePhoneNumber != null) {
      saveEmployeeContact.alternatePhoneNumber = this.general.reconverPhoneGoogleLib(saveEmployeeContact.alternatePhoneNumber);

    }
    if (saveEmployeeContact.fax != null) {
      saveEmployeeContact.fax = this.general.reconverPhoneGoogleLib(saveEmployeeContact.fax);

    }
    if (saveEmployeeContact.phoneNumber != null) {
      saveEmployeeContact.phoneNumber = this.general.reconverPhoneGoogleLib(saveEmployeeContact.phoneNumber);

    }
    let url=''
    if (this.ContactRelation?.ContactType == 'Client'  ) {
      url ="api/ClientContactInfo/SaveCliContactInfo";
    }
    else if (this.ContactRelation?.ContactType == 'Employee') {
      url ="api/EmployeeContactInfo/SaveEmpContactInfo";
    }
    else if(this.ContactRelation?.ContactType =='Referral'){
      url = "api/ReferralContactInfo/SaveReferralContactInfo";
    }  
    
    
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveEmployeeContact, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (this.contactinfo.id == "00000000-0000-0000-0000-000000000000") {
        document.getElementById('openContactModal').click();
        this.toastrService.success('Contact saved successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.ContactInfoForm.reset();
        this.contactinfo.id ='00000000-0000-0000-0000-000000000000'
      }
      else if (this.contactinfo.id != "00000000-0000-0000-0000-000000000000") {
        document.getElementById('openContactModal').click();
        this.toastrService.success('Contact updated successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.ContactInfoForm.reset();
        this.contactinfo.id = "00000000-0000-0000-0000-000000000000"
      }
      this.disabledsavedbutton = false;
      if (this.ContactRelation?.ContactType == 'Client' || this.global.OnboardType == "CLIENT") {
        this.getClientContactInfo();
      }
      else if (this.ContactRelation?.ContactType == 'Employee' || this.global.OnboardType == "EMPLOYEE") {
        this.getEmployeeContactInfo();
      }
      else if(this.ContactRelation?.ContactType =='Referral')
        this.getReferralContactInfo();
    }, (err: any) => {
      this.disabledsavedbutton = false;
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    })
  }
  isContactChange() {

    this.isCheckContactvalue = true;
  }
  TypeContactValueChange() {

    if (this.isCheckContactvalue == true) {
      document.getElementById('typemodal').click();
    }
    else {
      this.contactinfo.id = "00000000-0000-0000-0000-000000000000"
      document.getElementById("openContactModal").click();
      this.ContactInfoForm.reset();
      this.isCheckContactvalue = false;

    }
  }
  closetype() {
    document.getElementById('typemodal').click();

  }
  backtoContact() {
    this.contactinfo.id ="00000000-0000-0000-0000-000000000000"
    document.getElementById('typemodal').click();
    document.getElementById("openContactModal").click();
    this.ContactInfoForm.reset();
    this.isCheckContactvalue = false;
  }
  checkValidateEmail() {
    this.checkEmailValidation = false;
    if (this.contactinfo.email != null) {
      if (this.ContactInfoForm.controls.email.errors != null) {

        if (this.ContactInfoForm.controls.email.errors.invalidEmail) {
          this.checkEmailValidation = true;
        }
        else {
          this.checkEmailValidation = false;
        }
      }
    }
  }


  fp:any;
  getpermission() {
     let params = new URLSearchParams();
     if (this.ContactRelation?.ContactType == 'Client' || this.global.OnboardType=='CLIENT' ) {
       params.append("pagecode", "Client");
     }
     else{
       params.append("pagecode", "Employee");
     }
    
    // params.append("agencyId", this.global.agencyId);
     let url = "api/FunctionPermission/getfunctionpermissionemployee?";
     this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
       if (data != null) {
         this.fp = data;
       }
       else {
         this.fp = null;
       }
     },
       (err: HttpErrorResponse) => {
         this.fp = null;
       })
   }

   getReferralContactInfo() {
    let params = new URLSearchParams();
    if(this.ContactRelation != null && this.ContactRelation!= undefined)
      {
        params.append("ReferralId", this.ContactRelation.Id.toString());
      }
   
    let url = "api/ReferralContactInfo/GetReferralContactInfo?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClientEmployeeContactData = data;
      this.ClientEmployeeContactData?.forEach(ele => {
        ele.phoneNumber = (ele.phoneNumber != null) ? this.general.converPhoneGoogleLib(ele.phoneNumber) : null;
        ele.alternatePhoneNumber = (ele.alternatePhoneNumber != null) ? this.general.converPhoneGoogleLib(ele.alternatePhoneNumber) : null;
      })

    },
      (err: any) => {
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}




